import { useUserStore } from '@/store/modules/user';
import { trackerMap, TrackEvent, eventNameMap } from './key';
import { useOnceStore } from '@/store/modules/once';
import MainService from '@/service/main';
import TrackService from '@/service/track';
// import { EVENT } from '@/constant/global';
import { getDeviceFingerPrint } from '..';

// export type TrackerMap = typeof trackerMap;
// export type idType<T extends keyof typeof trackerMap> = (typeof trackerMap)[T][number];
// export function TK<T extends keyof TrackerMap>(NSKey: T, id: idType<T>, params: object = {}) {
//     const value = `${NSKey}${id}`;
//     window.collectEvent(NSKey, )
// }

export type idType<T extends keyof typeof trackerMap> = (typeof trackerMap)[T][number];
export function TK<T extends TrackEvent>(eventKey: T, page: string, isOperate = false) {
    // 火山引擎
    window.collectEvent(eventKey);

    // OCC
    // report({ name: eventKey, page, content: eventNameMap[eventKey] });
    report({ name: isOperate ? 'maievent-page-operate' : 'maievent-page-view', page, content: eventNameMap[eventKey] });
}

interface CollectFn extends Function {
    q: any[]
}
export async function setupTracker() {
    if (!useUserStore().finger) {
        const finger = await getDeviceFingerPrint();
        useUserStore().setFinger(finger);
    }

    window.collectEvent('init', {
        app_id: Number(import.meta.env.VITE_VOLCE_APP_ID), // 参考2.1节获取，注意类型是number而非字符串
        channel_domain: import.meta.env.VITE_VOLCE_REPORT_URL, // 设置私有化部署数据上送地址，参考2.2节获取
        log: true, // true:开启日志，false:关闭日志
        autotrack: true, // 全埋点开关，true开启，false关闭
        spa: true, // 对 spa 的支持，
        enable_stay_duration: true,
        enable_debug: false,
        reportTime: 5000,
    } as IInitParam);
    window.collectEvent('config', {
        user_unique_id: useUserStore().finger,
        custom_channel: import.meta.env.VITE_OCC_HK_H5_PLATFORM,
    } as IConfigParam);
    // 此处可添加设置uuid、设置公共属性等代码
    window.collectEvent('start'); // 通知SDK设置完毕，可以真正开始发送事件了
    // 初始化 OCC
    // initOCC();
}

/**
 * 手动在页面切换时上报
 */
export function reportWhilePageUpdate() {
    window.collectEvent("predefinePageView");
}

/**
 * 初始化 OCC
 */
export async function initOCC() {
    // 如果 token 未失效，放行
    if (useUserStore().checkOccAuth) return useOnceStore().exciteHasCheckOccAuth();
    const result = await MainService.getAuthToken();
    useUserStore().setTokenInfo(result.accessToken, result.expire);
    useOnceStore().exciteHasCheckOccAuth();
}

/**
 * 上报
 */
export async function report(payload: Parameters<typeof TrackService.report>[0]) {
    payload = {
        ...payload,
        occurredAt: new Date().toISOString(), // 触发时间
    }
    MainService.report(payload);
    // if (useOnceStore().hasCheckOccAuth) MainService.report(payload);
    // else useEventBus(EVENT.SET_OCC_TOKEN_SUCCESS).once(() => MainService.report(payload));
}